<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.375 17.9688V19.0181C9.375 19.8469 9.04576 20.6417 8.45971 21.2278L7.8125 21.875H17.1875L16.5403 21.2278C15.9542 20.6417 15.625 19.8469 15.625 19.0181V17.9688M21.875 5.46875V15.625C21.875 16.9194 20.8257 17.9688 19.5312 17.9688H5.46875C4.17433 17.9688 3.125 16.9194 3.125 15.625V5.46875M21.875 5.46875C21.875 4.17433 20.8257 3.125 19.5312 3.125H5.46875C4.17433 3.125 3.125 4.17433 3.125 5.46875M21.875 5.46875V12.5C21.875 13.7944 20.8257 14.8438 19.5312 14.8438H5.46875C4.17433 14.8438 3.125 13.7944 3.125 12.5V5.46875"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgMonitor',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
